import { globalConstants, blogConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  formData: {},
};
//Manipulating the state of admin portal based on actions and returning the state
export const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case blogConstants.GET_BLOGS + SUCCESS:
      return { ...state, data: action.data };
    case blogConstants.GET_BLOG_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    default:
      return state;
  }
};
